import { render } from "./CreateAlert.vue?vue&type=template&id=36cad263&scoped=true"
import script from "./CreateAlert.vue?vue&type=script&lang=js"
export * from "./CreateAlert.vue?vue&type=script&lang=js"

import "./CreateAlert.vue?vue&type=style&index=0&id=36cad263&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cad263"]])

export default __exports__